module.exports = __webpack_public_path__ + "static/media/risk_profile.e9ba78d1.svg";